import { useState, useEffect, useRef } from 'react';
import { END_OF_MESSAGE_DELAY_TIME } from '../../thread-history/constants/EndOfMessageDelayTime';
export default function useNewThreadPrompt({
  isThreadStarted,
  isThreadTransferred,
  toggleOnAndOffInputFocus
}) {
  const [isNewThreadPromptVisible, setIsNewThreadPromptVisible] = useState(!isThreadStarted || !!isThreadTransferred);
  const prevIsThreadStartedRef = useRef(isThreadStarted);
  const prevIsThreadTransferredRef = useRef(isThreadTransferred);

  // Show "thread ended" prompt after a delay when the thread ends or is transferred.
  useEffect(() => {
    const prevStarted = prevIsThreadStartedRef.current;
    const prevTransferred = prevIsThreadTransferredRef.current;
    prevIsThreadStartedRef.current = isThreadStarted;
    prevIsThreadTransferredRef.current = isThreadTransferred;
    if (!isThreadStarted && isThreadStarted !== prevStarted || isThreadTransferred && isThreadTransferred !== prevTransferred) {
      const timer = setTimeout(() => {
        setIsNewThreadPromptVisible(true);
        toggleOnAndOffInputFocus(false);
      }, END_OF_MESSAGE_DELAY_TIME);
      return () => clearTimeout(timer);
    }
  }, [isThreadStarted, isThreadTransferred, toggleOnAndOffInputFocus]);

  // Hide the "thread ended" prompt once a new thread has started.
  useEffect(() => {
    if (isThreadStarted && !isThreadTransferred) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsNewThreadPromptVisible(false);
    }
  }, [isThreadStarted, isThreadTransferred]);
  return isNewThreadPromptVisible;
}